import Debug from 'debug';

const debug = Debug('hotglue-cli');

function extendDebug(namespace) {
  return debug.extend(namespace);
}

export default extendDebug;
